import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const keyOf = (i) => `${i.id}|${i.size || ""}|${i.color || ""}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("olm_cart")) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  useEffect(() => { localStorage.setItem("olm_cart", JSON.stringify(items)); }, [items]);

  const add = (item) => {
    setItems((prev) => {
      const ex = prev.find((i) => keyOf(i) === keyOf(item));
      if (ex) return prev.map((i) => (keyOf(i) === keyOf(item) ? { ...i, qty: i.qty + item.qty } : i));
      return [...prev, item];
    });
    setOpen(true);
  };
  const setQty = (item, qty) => setItems((prev) => prev.map((i) => (keyOf(i) === keyOf(item) ? { ...i, qty: Math.max(1, qty) } : i)));
  const remove = (item) => setItems((prev) => prev.filter((i) => keyOf(i) !== keyOf(item)));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return <CartCtx.Provider value={{ items, add, setQty, remove, clear, count, open, setOpen }}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
